export enum PopulationEnum {
  aucun = 1,
  biatoss = 2,
  enseignant = 4
}
